var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3104 16.6974C17.4495 16.6634 17.5887 16.6263 17.7279 16.5923C19.4565 16.1501 21.4202 15.646 23.4582 15.7048C23.585 14.7337 24.4137 13.9823 25.4219 13.9823V8.53646C24.3302 8.53646 23.4458 7.65202 23.4427 6.56039C21.9893 6.50782 20.4492 6.85417 18.6896 7.30257C18.5505 7.33659 18.4113 7.3737 18.2721 7.41081C16.5435 7.85303 14.5798 8.3571 12.5418 8.29834C12.415 9.26937 11.5832 10.0208 10.5781 10.0208V15.4635C11.6698 15.4635 12.5542 16.348 12.5573 17.4396C14.0107 17.4922 15.5508 17.1458 17.3104 16.6974ZM9.09375 17.118V7.5778C9.09375 6.82943 9.87923 6.33155 10.5905 6.52637C13.0583 7.20671 15.5291 6.57585 18 5.94808C20.6873 5.26465 23.3747 4.57813 26.062 5.57699C26.5908 5.77181 26.9062 6.3099 26.9062 6.882V16.4222C26.9062 17.1737 26.1208 17.6685 25.4126 17.4736C22.9417 16.7933 20.4709 17.4242 18 18.0519C15.3127 18.7354 12.6253 19.4219 9.93799 18.423C9.40918 18.2282 9.09375 17.6901 9.09375 17.118ZM18 14.9688C16.6331 14.9688 15.526 13.639 15.526 12C15.526 10.361 16.6331 9.03125 18 9.03125C19.3669 9.03125 20.474 10.361 20.474 12C20.474 13.639 19.3669 14.9688 18 14.9688Z",
    fill: "#526077"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.13ebc379a01e990b88e3976500e60e4b.svg";
export { ForwardRef as ReactComponent };